/**
 * @Author Adnan
 * @since 1-8-21
 * @Description API endpoints for backend
 *
 **/
import { environment } from "../environments/environment";

let baseUrl = environment.baseUrl;

export class  URLConfig {
  //Auth Module
  public static login = baseUrl + "Admin/admin-login";
    public static sendOtp = baseUrl + "Guardian/guardian-login";
    public static verifyGuardianOtp = baseUrl + "Guardian/verify-guardian-otp";

    public static register = baseUrl + "Auth/register";
    public static registerStudent = baseUrl + "User/register-student";
        public static registerAdmin = baseUrl + "User/register-admin";
 public static updateAdmin = baseUrl + "User/admin-status";
  public static sendEmail = baseUrl + "Auth/reset-password";
  public static refreshToken = baseUrl + "Admin/refresh-token";
  public static changepassword = baseUrl + "Auth/change-password";
  public static forcelogout = baseUrl + "Admin/force-log-out";
  public static savetutorasses = baseUrl + "Tutor/save-tutor-assessment";

  ///Dashboard
  public static getStats = baseUrl + "Admin/dashboard";

  //user
    public static getAdmin = baseUrl + "User/admins";
  public static guardianDashboard = baseUrl + "Guardian/guardian-dashboard";

  public static getUser = baseUrl + "Admin/all-users";
    public static getSchool = baseUrl + "School/all-schools";
  public static getSchoolStats = baseUrl + "School/school-stats";

    public static cancelSubscription = baseUrl + "Subscription/cancel-subscription";
    public static applyCoupan = baseUrl + "Subscription/apply-coupon";
    public static blockStudent = baseUrl + "User/block-student-access";

  public static getUserSearch = baseUrl + "Admin/search-user";
  public static getOrderSearch = baseUrl + "Admin/search-order";
  public static getUserDetail = baseUrl + "Admin/search-user-by-id";
    public static getSchoolDetail = baseUrl + "School/school-detail";
    public static filterStudent = baseUrl + "Admin/school-filter";

  public static tutorRequest = baseUrl + "Admin/tutor-requests";
    public static allowRights = baseUrl + "Tutor/allow-rights";
    public static tutorassesment = baseUrl + "Tutor/tutor-assessments";
 
    public static createFolder = baseUrl + "AdminBucket/create-folder";
    public static getFolder = baseUrl + "AdminBucket/list-folders";
    public static saveFile = baseUrl + "AdminBucket/save-admin-file";
    public static getFolderFiles = baseUrl + "AdminBucket/folder-files";
    public static deleteFile = baseUrl + "AdminBucket/delete-admin-file";

  public static studentRequest = baseUrl + "Admin/student-requests";
  public static updateUser = baseUrl + "user/update-user";
  public static questionDetail = baseUrl + "Questions/get-request";
    public static updateRequestType = baseUrl + "Questions/change-request-type";


  //stores
  public static getStore = baseUrl + "Adminstats/get-stores";
  public static getQNA = baseUrl + "admin/request-data";
  
  public static getSearchStore = baseUrl + "Adminstats/search-store";
  public static getSearchQna = baseUrl + "Adminstats/search-store";
  public static postStoreBlock= baseUrl + "Admin/block-store";
  public static searchByTutor= baseUrl + "Admin/tutor-requests-by-email";

  public static getTutorRequests= baseUrl + "Tutor/tutor-rights";
  public static searchByStudent= baseUrl + "Admin/student-requests-by-email";
  public static requestFilter = baseUrl + "Questions/request-filter";
    public static approvedtutor = baseUrl + "Tutor/approved-tutors";
    public static pendingtutor = baseUrl + "Tutor/pending-tutors";


  //products
  public static getSubjects = baseUrl + "Subjects/all-subjects";
  public static getproducts = baseUrl + "Adminstats/get-pending-products";
  public static gettoppicks = baseUrl + "Admin/get-picked";
  public static addtoppicks = baseUrl + "Admin/add-to-picked";
  public static removetoppicks = baseUrl + "Admin/remove-picked";

  //rising label
  public static getRisingLabel = baseUrl + "Admin/get-rising-labels";
  public static addRisingLabel = baseUrl + "Admin/add-rising-labels";
  public static removeRisingLabel = baseUrl + "Admin/remove-rising-labels";

  //pending products
  public static getPendingPayment = baseUrl + "Adminstats/get-pending-payments";
    public static addPayment = baseUrl + "Bank/add-tutor-payment";

  public static getPendingOrder = baseUrl + "Admin/get-orders";

  //Hide Item
  public static hideItem = baseUrl + "Items/visible";
  public static ItemUpdate = baseUrl + "Items/item-update";

  //Shops
  public static shopDetail = baseUrl + "shop/shop-detail";
  public static shops = baseUrl + "home/all-shops";

  // items get endpoint
  public static itemDetail = baseUrl + "Adminstats/get-product-detail";
  public static itemOwnerDetail = baseUrl + "Items/item-detail-owner";
  public static editDetail = baseUrl + "Items/edit-item";

  //Delete Item
  public static deleteItem = baseUrl + "Items/delete-item";

  //Review 
  public static getReview = baseUrl + "Adminstats/get-all-comments";
  public static deleteReview = baseUrl + "Adminstats/delete-comment";
  public static approveReview = baseUrl + "Adminstats/approve-comment";

  //payment
  public static paymentRelease = baseUrl + "Adminstats/payment-release";
    public static paymentData = baseUrl + "Tutor/tutors-date-filter";
        public static tutorDues = baseUrl + "Tutor/tutors-dues";
    public static getTutorPayments = baseUrl + "Bank/get-tutor-payments";
    public static updateTutorPayments = baseUrl + "Bank/update-tutor-payment";



  //Dashboard 
  public static getDashboardGraphData = baseUrl + "Adminstats/admin-graph-onload";
  public static getDashboardGraphByYearData = baseUrl + "Adminstats/admin-graph-by-year";
  public static getDashboardGraphByYearRangeData = baseUrl + "Adminstats/admin-graph-by-year-range";


  //setting
  public static getSetting = baseUrl + "Adminstats/all-setting";
  public static updateCartAmount = baseUrl + "Adminstats/update-minimum-cart-amount";
  public static updateWeekShop = baseUrl + "Adminstats/update-week-shop";
  public static updateAutoApprove = baseUrl + "Adminstats/update-auto-approve";
  public static updateTopPicks = baseUrl + "Adminstats/update-top-picks";
  public static updateBanner = baseUrl + "Adminstats/update-banner";
  public static items = baseUrl + "Categories/get-catgories";
    public static getSettings = baseUrl + "AppSetting/get-setting-admin";
    public static updateAndroidVersion = baseUrl + "AppSetting/update-android-version";
    public static updateIosVersion = baseUrl + "AppSetting/update-ios-version";
    public static forceUpdate = baseUrl + "AppSetting/force-update";
    public static updatereferHeading = baseUrl + "AppSetting/update-refer-heading";
    public static updateTerms = baseUrl + "AppSetting/update-terms";
    public static updatecurrentVersion = baseUrl + "AppSetting/update-current-version";
    public static freeQNA = baseUrl + "AppSetting/free-qna-limit";
    public static freeEssay = baseUrl + "AppSetting/free-essay-limit";
    public static freeVideo = baseUrl + "AppSetting/free-video-limit";


  // telr requests
  public static getTelrRequests = baseUrl + "Admin/telr-request?";
  public static updateTelrRequest = baseUrl + "Admin/update-telr-request?";
  public static updateTelrRequestId = baseUrl + "Admin/update-telr-id?";

  // support
  public static getsupport = baseUrl + "info/all-info";
  public static getMessages = baseUrl + "Support/get-messages";
  public static replyMessage = baseUrl + "Support/reply-message";
  public static getLogoutRequests = baseUrl + "Support/get-logout-request";
  public static getUserDevices = baseUrl + "User/user-devices";


  // notification
  public static notification = baseUrl + "Admin/send-fcm";
    public static getNotifications = baseUrl + "Notification/get-admin-notifications";
    public static sendNotifications = baseUrl + "Notification/send-admin-notification";
    public static getCoupans = baseUrl + "Subscription/get-coupons";
    public static deleteCoupans = baseUrl + "Subscription/delete-coupon";
    public static getPackage = baseUrl + "Subscription/get-products";

  public static addSubject = baseUrl + "Subjects/add-subject";
  public static image = baseUrl + "Media/upload-media";
  public static videoUpload = baseUrl + "Media/upload-media-video";
    public static downloadImage = baseUrl + "Media/download-media";

  public static delMedia = baseUrl + "Media/delete-media";
  public static approveProfile = baseUrl + "Admin/approve-profile";
  public static blockProfile = baseUrl + "Admin/block-tutor-profile";
  public static submitAnswers = baseUrl + "Questions/submit-answer";
    public static addSchool = baseUrl + "School/add-school";
        public static updateSchool = baseUrl + "School/update-school";
  public static studentCount= baseUrl + "School/student-count";

    public static createCoupan = baseUrl + "Subscription/create-coupon";
    public static updateLimit = baseUrl + "Subscription/update-package-limits";

  // support
  public static spotlight = baseUrl + "Admin/get-spotlight";

  // support
  public static getUserDetails = baseUrl + "user/get-user";
 // roles and permissions
      public static addRole = baseUrl + "User/add-role";
      public static editRole = baseUrl + "User/edit-role";
      public static getRoles = baseUrl + "User/roles";
      public static addPermission = baseUrl + "User/add-permission";
      public static editPermission = baseUrl + "User/edit-permission";
      public static getPermission = baseUrl + "User/permissions";
      public static addUserRole = baseUrl + "User/add-user-role";
      public static removeUserRole = baseUrl + "User/remove-user-role";
      public static getUserRoles = baseUrl + "User/user-roles";
      public static getUserPermissions = baseUrl + "User/user-permissions";
        public static addUserRoles = baseUrl + "User/user-roles";
      public static addUserPermission = baseUrl + "User/add-user-permission";
            public static removeUserPermission = baseUrl + "User/remove-user-permission";


}
